import { render } from "./shopCartSettlement.vue?vue&type=template&id=bf925900&scoped=true"
import script from "./shopCartSettlement.vue?vue&type=script&lang=js"
export * from "./shopCartSettlement.vue?vue&type=script&lang=js"

import "./shopCartSettlement.vue?vue&type=style&index=0&id=bf925900&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf925900"]])

export default __exports__